import { Box, Popover, Typography } from '@mui/material';
import { PopoverProps } from 'src/components/PopoverTrigger';
import { useLocales } from 'src/locales';
import { PastSessionsList } from './PastSessionsList';

export const PastSessionsPopover = ({
  target,
  handleClose,
  channelId,
}: PopoverProps<{ channelId: string }>) => {
  const open = Boolean(target);
  const { translate } = useLocales();

  return (
    <Popover
      open={open}
      anchorEl={target}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      slotProps={{
        paper: {
          sx: { p: 1.5, width: '500px' },
        },
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Typography variant="h6">
          {translate('communicate.past_sessions')}
        </Typography>
        <PastSessionsList channelId={channelId} handleClose={handleClose} />
      </Box>
    </Popover>
  );
};
